import { CommonApiOptions } from "../../constants/api";
import configs from "../configs/apiConfigs";
import { BODY_TYPE, METHOD_TYPE } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandlers";

export const updateAccount = (data: any, patientUniqueId: any) => {
    const request: CommonApiOptions = {
        url: configs.API_URL + "patient/" + patientUniqueId + "/account/",
        apiOptions: {
            headers: attachHeader(true),
            withCredentials: true
        },
        method: METHOD_TYPE.POST,
        body: {
            type: BODY_TYPE.RAW,
            data: data
        }
    };
    return commonApi(request);
}